import { useState } from 'react';
import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

import { Logo } from 'play/atoms/logo/Logo';
import { InstruqtBrandingModal } from 'play/organisms/instruqt-branding-modal/InstruqtBrandingModal';

export interface SplashLayoutProps {
  topRight?: React.ReactNode;
  bottomCenter?: React.ReactNode;
  bottomLeft?: React.ReactNode;
  bottomRight?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  title?: React.ReactNode;
}

export const SplashLayout = ({
  topRight,
  bottomCenter,
  bottomLeft,
  bottomRight,
  children,
  className,
  title,
}: SplashLayoutProps) => {
  const [showBrandingModal, setShowBrandingModal] = useState(false);

  return (
    <div tw="absolute bg-blue-darkest flex flex-col inset-0 items-stretch text-white z-overlay" className={className}>
      <div tw="flex justify-between p-4 pb-0">
        <div tw="flex items-center">
          <Logo
            tw="h-7 mr-1 w-auto cursor-pointer"
            location="Splash screen"
            type="poweredBy"
            onClick={() => setShowBrandingModal(true)}
          />
          <InstruqtBrandingModal open={showBrandingModal} onClose={() => setShowBrandingModal(false)} />
          {title}
        </div>
        {topRight && <div tw="self-end">{topRight}</div>}
      </div>
      {children}
      {(bottomLeft || bottomCenter || bottomRight) && (
        <div tw="box-content flex h-4 items-center justify-between p-4 pt-1 lg:pt-4 xl:pt-5">
          {bottomLeft && <Aside>{bottomLeft}</Aside>}
          {bottomCenter}
          {bottomRight && <Aside isLast>{bottomRight}</Aside>}
        </div>
      )}
    </div>
  );
};

const Aside = styled.div<{ isLast?: boolean }>(({ isLast }) => [
  tw`flex text-base sm:w-26 md:w-42`,
  isLast && tw`justify-end`,
]);
